import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';
import { FC } from 'react';

export const Loader: FC<{
  title?: string;
  h?: number;
  w?: number;
  color?: string;
  align?: 'vertical' | 'horizontal';
}> = ({ title, h = 8, w = 8, color = 'text-primary', align = 'vertical' }) => {
  return (
    <div
      className={cn(
        'm-auto flex gap-2',
        align === 'vertical' ? 'flex-col items-center' : 'flex-row',
      )}
    >
      <Loader2 className={cn('animate-spin text-muted', `h-${h}`, `w-${w}`, color)} />
      {title && <p>{title}</p>}
    </div>
  );
};
